import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuNode, KeyValuePair } from '../../../../classes';
import { TranslationService } from '../../../../services/translation.service';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {
	@Input('debug') debug:boolean = false;
	enabled_buttons:Array<string>;
	title:string;
	eventSubscription:any;
	mode:string;
	dashIcon:string="";
	tr(str:string):string{
		return this.translator.tr(str);
	}
	constructor(private menuService: MenuService, private ioService: DataIoService,private translator: TranslationService) {

	}
	getLineClass(item):string{
		switch(this.lines(item)){
			case 0:
			case 1: {
				return '';
			}
			case 2:{
				return 'double';
			}
			case 3:{
				return 'triple';
			}
			case 4:{
				return 'quadruple';
			}
			case 5:{
				return 'quintuple';
			}
			case 6:{
				return 'sextuple';
			}
			case 7:{
				return 'septuple';
			}
			case 8:{
				return 'octuple';
			}
			case 9:{
				return 'nontuple';
			}
			case 10:{
				return 'dectuple';
			}
		}
	}
	hasParameter(p:string):boolean{
		return this.menuService.hasParameter(p);
	}
	lines(item:KeyValuePair):number{
		if(item instanceof KeyValuePair){
			if(typeof(item.value)=="string"){
				return ((item.value.match(/\n/g) || '').length + 1)
			}
		}
		return 1;
	}
	
	_isDouble(item):boolean{
		if(item instanceof KeyValuePair){
			if(item.value == undefined){
				return false;
			}
			if(typeof(item.value) == "string" ){
				return item.value.includes('\n');
			}else{
				return false;
			}
		}else{
			return false;
		}
	}
	dictionary:Array<KeyValuePair>;
	getDictionary(): Array<KeyValuePair>{
		if(this.dictionary){
			return this.dictionary;
		}
		let node = this.menuService.getCurrentNode();
		if(node.getDictionary().length != 0){
			//console.log("returning existing dictionary.");
			this.dictionary = node.getDictionary();
			return this.dictionary;
		}

		let zoneIds = this.ioService.deviceInfo().getZoneIds();
		let dict = new Array<KeyValuePair>()
		
		switch(node.getValue()){
			case 'installation_assistent':{
				let di = this.ioService.deviceInfo();
				let hcc = di.getHeatingCircuitCount();
				let solar_option = di.getRawValue('wizard_solar_option');
				let zone_option = di.getRawValue('wizard_zone_option');
				
				dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMSCHEME'),this.ioService.deviceInfo().getScale('systemschema_code').getCurrentValue()));
				dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_OUTSIDE_TEMPERATURE'),this.translator.tr('WIZARD_MAGIC_SCREEN_OK')));
				if(di.simulatorConfig.hasVR70() && !di.simulatorConfig.hasVR71()){
					if( ['WIZARD_SOLAR_OPTIONS_ENUM1','WIZARD_SOLAR_OPTIONS_ENUM2'].includes(solar_option) && ['WIZARD_SELECT_CIRCUIT_OPTION_ENUM1'].includes(zone_option)) {
						this.ioService.deviceInfo().getScale('configuration_vr70').setCurrentValue(1);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR70'), di.getScale('configuration_vr70').getCurrentValue()));

						let keyLine ="";
						keyLine+= this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						let valueLine = ""
						valueLine +="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						dict.push(new KeyValuePair(keyLine,valueLine));

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1');
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}




					if( ['WIZARD_SOLAR_OPTIONS_ENUM1','WIZARD_SOLAR_OPTIONS_ENUM2'].includes(solar_option) && ['WIZARD_SELECT_CIRCUIT_OPTION_ENUM2','WIZARD_ZONE_OPTIONS_ENUM3'].includes(zone_option)) {
						this.ioService.deviceInfo().getScale('configuration_vr70').setCurrentValue(1);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR70'), di.getScale('configuration_vr70').getCurrentValue()));

						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2');
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5_6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2');
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}






					if( ['WIZARD_SOLAR_OPTIONS_ENUM1','WIZARD_SOLAR_OPTIONS_ENUM2'].includes(solar_option) && ['WIZARD_ZONE_OPTIONS_ENUM4'].includes(zone_option)) {
						this.ioService.deviceInfo().getScale('configuration_vr70').setCurrentValue(1);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR70'), di.getScale('configuration_vr70').getCurrentValue()));

						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2');
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5_6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2');
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}





					if( ['WIZARD_SOLAR_OPTIONS_ENUM1','WIZARD_SOLAR_OPTIONS_ENUM2'].includes(solar_option) && ['WIZARD_ZONE_OPTIONS_ENUM5'].includes(zone_option)) {
						
						this.ioService.deviceInfo().getScale('configuration_vr70').setCurrentValue(5);
						
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR70'),this.ioService.deviceInfo().getScale('configuration_vr70').getCurrentValue()));
						

						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5_6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2');
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}



					// solare ww-untert.
					if( ['WIZARD_SOLAR_OPTIONS_ENUM3'].includes(solar_option) && ['WIZARD_SELECT_CIRCUIT_OPTION_ENUM1','WIZARD_SELECT_CIRCUIT_OPTION_ENUM2','WIZARD_ZONE_OPTIONS_ENUM3','WIZARD_ZONE_OPTIONS_ENUM4','WIZARD_ZONE_OPTIONS_ENUM5'].includes(zone_option)) {
						this.ioService.deviceInfo().getScale('configuration_vr70').setCurrentValue(6);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR70'), di.getScale('configuration_vr70').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_DHW_SENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORSENSOR')+"\n";
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n ";
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL')+"\n";
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						valueLine = "\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_LEGIONELLAPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5_6_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_ZONEVALVE')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}

					// allstor, 1 direkter hk
					if( ['WIZARD_SOLAR_OPTIONS_ENUM4'].includes(solar_option) && ['WIZARD_SELECT_CIRCUIT_OPTION_ENUM1'].includes(zone_option)) {
						console.log("342");
						this.ioService.deviceInfo().getScale('configuration_vr70').setCurrentValue(3);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR70'), di.getScale('configuration_vr70').getCurrentValue()));
						


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPCH')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n ";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMCH')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						valueLine = "\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}

					// allstor, 1 direkter hk
					if( ['WIZARD_SOLAR_OPTIONS_ENUM4'].includes(solar_option) && ['WIZARD_SELECT_CIRCUIT_OPTION_ENUM2','WIZARD_ZONE_OPTIONS_ENUM3'].includes(zone_option)) {
						this.ioService.deviceInfo().getScale('configuration_vr70').setCurrentValue(3);
						console.log("403");
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR70'), di.getScale('configuration_vr70').getCurrentValue()));
						


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPCH')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n ";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMCH')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5_6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						valueLine = "\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}




					// allstor, 1 gemischter hk / 2 gemischte hk
					if( ['WIZARD_SOLAR_OPTIONS_ENUM4'].includes(solar_option) && ['WIZARD_ZONE_OPTIONS_ENUM4','WIZARD_ZONE_OPTIONS_ENUM5'].includes(zone_option)) {
						this.ioService.deviceInfo().getScale('configuration_vr70').setCurrentValue(3);
						console.log("468");
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR70'), di.getScale('configuration_vr70').getCurrentValue()));
						


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPCH')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n ";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMCH')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5_6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						valueLine = "\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}





					// solare ww-unterst., *
					if( ['WIZARD_SOLAR_OPTIONS_ENUM5'].includes(solar_option) && ['WIZARD_SELECT_CIRCUIT_OPTION_ENUM1','WIZARD_SELECT_CIRCUIT_OPTION_ENUM2','WIZARD_ZONE_OPTIONS_ENUM3','WIZARD_ZONE_OPTIONS_ENUM4','WIZARD_ZONE_OPTIONS_ENUM5'].includes(zone_option)) {
						this.ioService.deviceInfo().getScale('configuration_vr70').setCurrentValue(12);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR70'), di.getScale('configuration_vr70').getCurrentValue()));
						


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_1TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_DIFFERENCETEMPSENSOR1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_DIFFERENCETEMPSENSOR2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n ";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL')+"\n";
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_DIFFERENCETEMPOUTPUT')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5_6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						valueLine = "\n\n\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						/*
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
						*/
					}
				}
				if(di.simulatorConfig.hasVR71()){
					// solare ww-unterst., *

					
					let hcc = di.getScale('wizard_heatingcircuit_count').getCurrentValue();
					if( ['WIZARD_SOLAR_OPTIONS_ENUM1','WIZARD_SOLAR_OPTIONS_ENUM2'].includes(solar_option) && [1].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(3);
						console.log("603");
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1');
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1');
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON');
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1');
						valueLine = "\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						/*
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
						*/
					}





					if( ['WIZARD_SOLAR_OPTIONS_ENUM1','WIZARD_SOLAR_OPTIONS_ENUM2'].includes(solar_option) && [2].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(3);
						console.log("665");
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2');
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2');
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON');
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2');
						valueLine = "\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						/*
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
						*/
					}




					if( ['WIZARD_SOLAR_OPTIONS_ENUM1','WIZARD_SOLAR_OPTIONS_ENUM2'].includes(solar_option) && [3,4,5,6,7,8,9].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(3);
						console.log("732");
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC3');
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC3');
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON');
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC3')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						/*
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
						*/
					}


					let solarbuffers=di.getScale('solar_buffer_count').getCurrentValue();

					if( ['WIZARD_SOLAR_OPTIONS_ENUM3','WIZARD_SOLAR_OPTIONS_ENUM5'].includes(solar_option) && solarbuffers == 1 && [1].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(2);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_DHW_SENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORSENSOR');
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC3')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						/*
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
						*/
					}






					if( ['WIZARD_SOLAR_OPTIONS_ENUM3','WIZARD_SOLAR_OPTIONS_ENUM5'].includes(solar_option) && solarbuffers == 1 && [2].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(2);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_DHW_SENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORSENSOR');
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC3')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						/*
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
						*/
					}





					if( ['WIZARD_SOLAR_OPTIONS_ENUM3','WIZARD_SOLAR_OPTIONS_ENUM5'].includes(solar_option) && solarbuffers == 1 && [3,4,5,6,7,8,9].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(2);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC3')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_DHW_SENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORSENSOR');
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC3')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						/*
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
						*/
					}



					if( ['WIZARD_SOLAR_OPTIONS_ENUM3','WIZARD_SOLAR_OPTIONS_ENUM5'].includes(solar_option) && solarbuffers == 2 && [1].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(1);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_2TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_DHW_SENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_1TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORSENSOR');
						valueLine ="\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S9')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						/*
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
						*/
					}



					if( ['WIZARD_SOLAR_OPTIONS_ENUM3','WIZARD_SOLAR_OPTIONS_ENUM5'].includes(solar_option) && solarbuffers == 2 && [2,3,4,5,6,7,8,9].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(1);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_2TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_DHW_SENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_1TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORSENSOR');
						valueLine ="\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S9')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Optionale Aktoren
						**/
						/*
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3_4_1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_CH_DHW')
						valueLine = "";
						dict.push(new KeyValuePair(keyLine,valueLine));
						*/
					}




					if( ['WIZARD_SOLAR_OPTIONS_ENUM4'].includes(solar_option) && solarbuffers == 1 && [1].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(6);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_1TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_2TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMDHW');
						valueLine ="\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S9')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1');
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON');
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1');
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**

							Optionale Aktorne
						*/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1');
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}





					if( ['WIZARD_SOLAR_OPTIONS_ENUM4'].includes(solar_option) && solarbuffers == 1 && [2].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(6);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_1TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_2TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMDHW');
						valueLine ="\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S9')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON');
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**

							Optionale Aktorne
						*/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1');
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}




					if( ['WIZARD_SOLAR_OPTIONS_ENUM4'].includes(solar_option) && solarbuffers == 1 && [3,4,5,6,7,8,9].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(6);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_1TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_2TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMDHW');
						valueLine ="\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S9')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S11')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON');
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n\n\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**

							Optionale Aktorne
						*/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1');
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}




					if( ['WIZARD_SOLAR_OPTIONS_ENUM4'].includes(solar_option) && solarbuffers == 2 && [1].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(6);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_1TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_2TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_2TANKBOTTOMSENSOR');
						valueLine ="\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S9')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S11')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON');
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**

							Optionale Aktorem
						*/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1');
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}





					if( ['WIZARD_SOLAR_OPTIONS_ENUM4'].includes(solar_option) && solarbuffers == 2 && [2].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(6);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_1TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_2TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_2TANKBOTTOMSENSOR');
						valueLine ="\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S9')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S11')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON');
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**

							Optionale Aktorem
						*/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1');
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}




					if( ['WIZARD_SOLAR_OPTIONS_ENUM4'].includes(solar_option) && solarbuffers == 2 && [3,4,5,6,7,8,9].includes(hcc) ) {
						this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(6);
						dict.push(new KeyValuePair(this.translator.tr('WIZARD_MAGIC_SCREEN_CONFIG_VR71'),this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue()));


						let keyLine ="";
						let valueLine = ""

						/**
							Notwendige Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_FLOWTEMPHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S4')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_1TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_2TANKBOTTOMSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S7')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERTOPDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMDHW')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_2TANKBOTTOMSENSOR');
						valueLine ="\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK');
						
						dict.push(new KeyValuePair(keyLine,valueLine));

						/**
							Optionale Sensoren
						**/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SYSTEMFLOWTEMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_BUFFERBOTTOMCH')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARYIELDSENSOR')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S9')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S11')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_EXTDEMANDHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_S12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_SOLARSTATIONPWMSIGNAL');
						
						valueLine ="\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_OK')+"\n";
						//valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON')+"\n";
						valueLine+=this.translator.tr('WIZARD_MAGIC_SCREEN_ON');
						
						
						
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**
							Notwendige Aktoren
						**/

						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC3')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n\n\n\n\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));


						/**

							Optionale Aktorem
						*/
						keyLine = this.translator.tr('WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R1')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC1')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R2')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_HEATINGPUMPHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R3')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_SOLARTANK')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R5')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_COLLECTORPUMP')+"\n";
						keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R6')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_3WV_LOADINGPPUMP')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R7_8')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC1');
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R9_10')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC2')+"\n";
						//keyLine += this.translator.tr('WIZARD_MAGIC_SCREEN_R11_12')+" "+this.translator.tr('WIZARD_MAGIC_SCREEN_MIXERHC3');
						valueLine = "\n\n";
						dict.push(new KeyValuePair(keyLine,valueLine));
					}


				}
				/*
					"WIZARD_MAGIC_SCREEN_OFF"
	  				"WIZARD_MAGIC_SCREEN_ON"
  					"WIZARD_MAGIC_SCREEN_OK"
  				*/
  				/*
				  "WIZARD_MAGIC_SCREEN_NECESSARY_SENSORS"
				  "WIZARD_MAGIC_SCREEN_OPTIONAL_SENSORS"
				  "WIZARD_MAGIC_SCREEN_NECESSARY_ACTUATORS"
				  "WIZARD_MAGIC_SCREEN_OPTIONAL_ACTUATORS"
				*/
				break;
			}
			case "temperatures":{

				for(let zone of zoneIds){
					let zoneData=this.ioService.deviceInfo().getZoneById(zone);
					dict.push(new KeyValuePair(zoneData.getName(),zoneData.getSensor('temperature','room_temperature')));
				}
				let defaultZone = this.ioService.deviceInfo().getZoneById(this.ioService.deviceInfo().getDefaultZoneId());
				if(defaultZone.getRawValue('warmwasserspeicher') != 'ENUM_TYPE_OF_DHW_CIRCUIT_DEACTIVATED'){
					dict.push(new KeyValuePair(this.translator.tr("CURRENT_TEMPERATURE_NATIVE_DHW"),defaultZone.getSensor('temperature','water')));
				}
				for(let hcId of this.ioService.deviceInfo().getHeatingCircuitIds()){
					let hc = this.ioService.deviceInfo().getHeatingCircuitById(hcId);
					//dict.push(new KeyValuePair(this.translator.tr("CURRENT_TEMPERATURE_DHW_"+hcId),hc.getScale('warmwassertemperatur')));
				}
				break;

			}
			case 'zeitprogrammassistent_summary':{
				let zpa=this.ioService.getZeitprogrammAssistent().getFrameManager();
				let weekDaysExample = zpa.getTimeFrames(0);
				weekDaysExample.sort(function(a,b){
					return b.getBegin().getHours()-a.getBegin().getHours();
				});
				let weekEndExample = zpa.getTimeFrames(6);
				dict.push(new KeyValuePair(this.tr('LABEL_TIME_PROGRAM_ASSISTANT_SUMMARY_COMFORT_TEMPERATURE'),this.ioService.getZeitprogrammAssistent().getScale('wunschtemperatur').toString()))
				if(weekDaysExample.length == 1){
					dict.push(new KeyValuePair(this.tr("LABEL_TIME_PROGRAM_ASSISTANT_SUMMARY_WORKING_DAYS"),weekDaysExample[0].intervalString()))
				}else{
					dict.push(new KeyValuePair(this.tr("LABEL_TIME_PROGRAM_ASSISTANT_SUMMARY_WORKING_DAYS"),weekDaysExample[1].intervalString()+"\n"+weekDaysExample[0].intervalString()))
				}
				dict.push(new KeyValuePair(this.tr('LABEL_TIME_PROGRAM_ASSISTANT_SUMMARY_WEEKEND'),weekEndExample[0].intervalString()))
				break;
			}
			case 'devices':{
				dict = this.ioService.getConnectedDevicesList();
				break;

			}
			case "humidities":{

				for(let zone of zoneIds){
					let zoneData=this.ioService.deviceInfo().getZoneById(zone);
					dict.push(new KeyValuePair(zoneData.getName(),zoneData.getSensor('humidity','humidity').toString().replace('rel','')));
				}
				break;
			}
			case 'contacts':{
				dict = this.ioService.getContacts();
			}
			default:{

			}
		}
		this.dictionary=dict;
		//console.log("Lines: "+this.getLines());
		if(this.getLines() > this.scrollbarLines){
			//console.log("Enabling slider.");
			this.menuService.setScrollbarNeededByHelpWidget(true);

		}else{
			//console.log("not Enabling slider.");
		}
		return dict;

		
	}

	getLines(){
		let num =0;
		//console.log("Counting elements.");
		for(let kvp of this.dictionary){
			let kl=1;
			if(kvp.key.match){
			 kl = (kvp.key.match(/\\n/g)||[]).length;
			}
			let vl = 1;
			if(kvp.value.match){
				vl=(kvp.value.match(/\\n/g)||[]).length;
			}
			if(kl == 1 && vl == 1){
				num++;
			}else{
				if(kl > vl){
					num+=kl;
				}else{
					num+=vl;
				}
			}
		}
		if(num == 0){
			return this.dictionary.length;
		}
		return num;
	}
	_initial_top=((100/240)*69);
	_step_height=((100/240)*23);
	_step=0;
	_top_unit='%';
	scrollbarLines=7
	top:string;


	applyTop(){
		let t = this._initial_top;
		t-=this._step*this._step_height;
		this.top = t+this._top_unit;
	}


	ngOnInit() {
		this.top = this._initial_top+this._top_unit;
		this.mode = "default";
		if(this.menuService.hasParameter('setup')){
			this.mode = 'setup';
		}
		
		this.title = this.menuService.currentNode.getTitle();
		this.dashIcon = this.menuService.currentNode.getIcon();
		this.eventSubscription = this.ioService.inputs.events$.subscribe(
			(event)=>{this.eventHandler(event);}
			);
	}

	ngOnDestroy(){
			this.eventSubscription.unsubscribe();
	}

	get opacity():number{
		if(this._step > 2){
			return 0;
		}
		return 1-(this._step/2);
	}


	maxSteps(){
		let count = 0;
		for(let item of this.getDictionary()){
			count+= this.lines(item);
		}
		if(count > 4){
			return count-4;
		}else{
			return 0;
		}
	}


	panStep=0.25;
	eventHandler(event){
		switch(event){			
			case 'confirm':{
				if(this.menuService.hasNextMenuItem()){
					this.menuService.selectNextMenuItem();
				}
				break;
			}
			case 'panup':{
				console.log("panning down.");
				if(this._step < this.maxSteps()){
					this._step+=this.panStep;
					this.applyTop();
				}
				break;
			}
			case 'down':{
				if(this._step < this.maxSteps()){
					this._step++;
					this.applyTop();
				}
				break;
			}
			case 'panend':{
				console.log("panning end.");
				this._step = Math.round(this._step);
				break;
				this.applyTop();
			}
			case 'pandown':{
				console.log("panning up.");
				if(this._step >= this.panStep){
					this._step-=this.panStep;
					this.applyTop();
				}
				break;
			}
			case 'up':{
				if(this._step >= 1){
					this._step--;
					this.applyTop();
				}
				break;
			}
			case 'back':{
				
		        if(this.menuService.getCurrentNode().hasBackTarget()){
		            console.log("Goto backtarget ");
		            let backTarget = this.menuService.getCurrentNode().getBackTargetNode()
		            
		            console.log("Backtarget is: "+backTarget.getTitle());
		            this.menuService.goto(backTarget);
		            return;

		        }
				if(this.menuService.hasPreviousMenuItem()){
					this.menuService.selectPreviousMenuItem();
				}else{
					this.menuService.hierarchyUp();
				}
				break; 
			}
		}
	}
}
